import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=561ef332&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561ef332",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561ef332')) {
      api.createRecord('561ef332', component.options)
    } else {
      api.reload('561ef332', component.options)
    }
    module.hot.accept("./NavItem.vue?vue&type=template&id=561ef332&scoped=true", function () {
      api.rerender('561ef332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/LayoutHead/HeadNav/NavItem.vue"
export default component.exports